import React from "react";

// Assets
import { ShellContainer, ShellContent, ShellRoutes } from "./styles";

// Components
import Menu from "../../components/Menu";
import { Container } from "../../settings/layout";

import { Route, Switch, useLocation } from "react-router";
import privateRoutes from "../../routes/private";

import { TransitionGroup, CSSTransition } from "react-transition-group";

const Shell = () => {
    let location = useLocation();

    return (
        <ShellContainer>
            <Menu />

            <ShellContent>
                <ShellRoutes>
                    <Container>
                        <TransitionGroup>
                            <CSSTransition
                                key={location.key}
                                timeout={500}
                                classNames="alert"
                            >
                                <Switch location={location}>
                                    {privateRoutes.map((route, index) => (
                                        <Route
                                            {...route}
                                            key={`private_route_${index}`}
                                        />
                                    ))}
                                </Switch>
                            </CSSTransition>
                        </TransitionGroup>
                    </Container>
                </ShellRoutes>
            </ShellContent>
        </ShellContainer>
    );
};

export default Shell;
